$(document).ready(function() {
    $('#scrollToTop').click(function() {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    $('#scrollToBottom').click(function() {
        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
    });

    // Fade in/out effect
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('#scrollToTop').fadeIn();
        } else {
            $('#scrollToTop').fadeOut();
        }
    });

    $('#scrollToTop').hide(); // Start hidden
}); 